import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Props as SearchFormProps, SearchFormHorizontalFullWidth } from '../SearchFormHorizontalFullWidth';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1youfq8",
  propsAsIs: false
});
export const KiwiSearchForm = ({
  checkIn,
  checkOut,
  destinationButtonDisplayValue,
  destinationInputDisplayValue,
  numberOfAdults,
  numberOfChildren,
  numberOfRooms,
  onDestinationPickerClick,
  onCheckInDatePickerClick,
  onCheckOutDatePickerClick,
  onGuestPickerClick,
  onSubmit,
  isDestinationPickerOpen,
  isCheckInPickerOpen,
  isCheckOutPickerOpen,
  isGuestPickerOpen,
  guestPickerRef,
  destinationInputRef,
  onSuggestionsRequested,
  destinationHasError,
  isRoomsLabelShown
}: SearchFormProps) => {
  const {
    isDesktopXs
  } = useDeviceLayout();
  return <Wrapper>
      <SearchFormHorizontalFullWidth checkIn={checkIn} checkOut={checkOut} destinationButtonDisplayValue={destinationButtonDisplayValue} destinationInputDisplayValue={destinationInputDisplayValue} numberOfAdults={numberOfAdults} numberOfChildren={numberOfChildren} numberOfRooms={numberOfRooms} onDestinationPickerClick={onDestinationPickerClick} onCheckInDatePickerClick={onCheckInDatePickerClick} onCheckOutDatePickerClick={onCheckOutDatePickerClick} onGuestPickerClick={onGuestPickerClick} onSubmit={onSubmit} isDestinationPickerOpen={isDestinationPickerOpen} isCheckInPickerOpen={isCheckInPickerOpen} isCheckOutPickerOpen={isCheckOutPickerOpen} isGuestPickerOpen={isGuestPickerOpen} guestPickerRef={guestPickerRef} destinationInputRef={destinationInputRef} onSuggestionsRequested={onSuggestionsRequested} destinationHasError={destinationHasError} isRoomsLabelShown={isRoomsLabelShown} isTextLabel={!isDesktopXs} />
    </Wrapper>;
};

require("./KiwiSearchForm.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./KiwiSearchForm.tsx");